import React, { useEffect, useMemo, useState } from 'react';
import api from '../services/api';

// API URL birleştirme burada yapılmaz. /api/api hatasını engellemek için merkezi api servisi kullanılır.
const SIGNAL_VISIBLE_MS = 5 * 60 * 1000;

const getSignalAge = (createdAt) => {
  const createdTime = new Date(createdAt).getTime();
  const diffMs = Date.now() - createdTime;
  const minutes = Math.floor(diffMs / 60000);

  if (!Number.isFinite(createdTime) || minutes <= 0) return 'az önce';
  return `${minutes} dk önce`;
};

function LiveSignalCenter() {
  const [signals, setSignals] = useState([]);
  const [open, setOpen] = useState(false);
  const [now, setNow] = useState(Date.now());

  const closePanel = () => setOpen(false);
  const openPanel = () => setOpen(true);

  const fetchSignals = async () => {
    try {
      const data = await api.getRecentLiveSignalEvents();
      const events = data?.events || data?.signals || [];
      setSignals(Array.isArray(events) ? events : []);
    } catch (error) {
      // Canli sinyal yardimci ozelliktir; ana sayfa/premium sayfalarini bozmasin.
      setSignals([]);
      if (process.env.NODE_ENV !== 'production') {
        console.error('LIVE_SIGNAL_FETCH_ERROR', error);
      }
    }
  };

  useEffect(() => {
    fetchSignals();

    const fetchInterval = setInterval(fetchSignals, 15000);
    const clockInterval = setInterval(() => setNow(Date.now()), 10000);

    return () => {
      clearInterval(fetchInterval);
      clearInterval(clockInterval);
    };
  }, []);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') closePanel();
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, []);

  const visibleSignals = useMemo(() => {
    return [...signals]
      .filter((signal) => {
        const createdTime = new Date(signal.createdAt || signal.created_at || Date.now()).getTime();
        return Number.isFinite(createdTime) && now - createdTime <= SIGNAL_VISIBLE_MS;
      })
      .sort((a, b) => {
        const aTime = new Date(a.createdAt || a.created_at || 0).getTime();
        const bTime = new Date(b.createdAt || b.created_at || 0).getTime();
        return bTime - aTime;
      });
  }, [signals, now]);

  return (
    <>
      <button
        type="button"
        className="ta-signal-bell"
        onClick={openPanel}
        title="Canlı AI Sinyalleri"
        aria-label="Canlı AI Sinyalleri"
      >
        🔔
        {visibleSignals.length > 0 && (
          <span className="ta-signal-count">{visibleSignals.length}</span>
        )}
      </button>

      <button
        type="button"
        className={`ta-signal-backdrop ${open ? 'is-open' : ''}`}
        onClick={closePanel}
        aria-label="Canlı sinyal panelini kapat"
      />

      <aside className={`ta-signal-panel ${open ? 'is-open' : ''}`} aria-hidden={!open}>
        <div className="ta-signal-header">
          <div>
            <strong>Canlı AI Sinyalleri</strong>
            <span>Son sinyaller</span>
          </div>

          <button
            type="button"
            className="ta-signal-close"
            onClick={closePanel}
            aria-label="Kapat"
          >
            ×
          </button>
        </div>

        <div className="ta-signal-list">
          {visibleSignals.length === 0 && (
            <div className="ta-signal-empty">
              Henüz kayıtlı canlı sinyal yok.
            </div>
          )}

          {visibleSignals.map((signal) => (
            <div className="ta-signal-item" key={signal._id || `${signal.fixtureId}-${signal.createdAt}`}>
              <div className="ta-signal-row">
                <strong>🔥 {signal.title}</strong>
                <small>{getSignalAge(signal.createdAt || signal.created_at)}</small>
              </div>

              <div className="ta-signal-match">
                {signal.homeTeam} - {signal.awayTeam}
              </div>

              <div className="ta-signal-meta">
                {signal.minute}' | Momentum {signal.momentum}/100 | Güven %{signal.confidence}
              </div>

              {signal.message && <p>{signal.message}</p>}
            </div>
          ))}
        </div>
      </aside>
    </>
  );
}

export default LiveSignalCenter;
